import PropTypes from 'prop-types';

export const CustomItemLivestreamSiteOrganDefault = (params) => ({
    screen_name: [
        {
            name: 'ライブ配信情報',
            value: params?.screen_name?.livestream_info,
            key: 'livestream_info',
        },
        {
            name: 'ライブ配信情報編集',
            value: params?.screen_name?.livestream_info_edit,
            key: 'livestream_info_edit',
        },
    ],
    field_name: [
        {
            name: 'タイトル',
            value: params?.field_name?.title,
            key: 'title',
        },
        {
            name: '出演者',
            value: params?.field_name?.performer,
            key: 'performer',
        },
        {
            name: '時間帯',
            value: params?.field_name?.time_zone,
            key: 'time_zone',
        },
        {
            name: '日程',
            value: params?.field_name?.dates,
            key: 'dates',
        },
        {
            name: '有料・無料',
            value: params?.field_name?.paid_and_free,
            key: 'paid_and_free',
        },
        {
            name: 'アクション',
            value: params?.field_name?.action,
            key: 'action',
        },
        {
            name: '出演者プロフィール',
            value: params?.field_name?.performer_profile,
            key: 'performer_profile',
        },
        {
            name: '配信内容',
            value: params?.field_name?.contents,
            key: 'contents',
        },
        {
            name: '申込最大人数',
            value: params?.field_name?.maximum_number_applicants,
            key: 'maximum_number_applicants',
        },
        {
            name: '資料',
            value: params?.field_name?.information,
            key: 'information',
        },
        {
            name: '資料請求受付',
            value: params?.field_name?.document_request_reception,
            key: 'document_request_reception',
        },
        {
            name: 'アンケート',
            value: params?.field_name?.questionnaire,
            key: 'questionnaire',
        },
        {
            name: 'お問合せ',
            value: params?.field_name?.inquiries,
            key: 'inquiries',
        },
        {
            name: '料金',
            value: params?.field_name?.fee,
            key: 'fee',
        },
    ],
    button_name: [
        {
            name: 'プレビュー',
            value: params?.button_name?.livestream_preview,
            key: 'livestream_preview',
        },
    ],
});

CustomItemLivestreamSiteOrganDefault.defaultProps = {
    params: {},
};

CustomItemLivestreamSiteOrganDefault.propTypes = {
    params: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export const CustomItemSeminarSiteOrganDefault = (params) => ({
    screen_name: [
        {
            name: 'セミナー情報管理',
            value: params?.screen_name?.seminar_info_management,
            key: 'seminar_info_management',
        },
        {
            name: 'セミナー詳細',
            value: params?.screen_name?.seminar_details,
            key: 'seminar_details',
        },
        {
            name: 'セミナー情報編集',
            value: params?.screen_name?.seminar_info_edit,
            key: 'seminar_info_edit',
        },
    ],
    field_name: [
        {
            name: '開催日',
            value: params?.field_name?.dates,
            key: 'dates',
        },
        {
            name: '時間',
            value: params?.field_name?.time,
            key: 'time',
        },
        {
            name: '講演名',
            value: params?.field_name?.lecture_name,
            key: 'lecture_name',
        },
        {
            name: '講演者',
            value: params?.field_name?.speaker,
            key: 'speaker',
        },
        {
            name: '講演者写真',
            value: params?.field_name?.speaker_photo,
            key: 'speaker_photo',
        },
        {
            name: '講演内容',
            value: params?.field_name?.lecture_content,
            key: 'lecture_content',
        },
        {
            name: '再生時間',
            value: params?.field_name?.playback_time,
            key: 'playback_time',
        },
        {
            name: '状況',
            value: params?.field_name?.situation,
            key: 'situation',
        },
        {
            name: 'アクション',
            value: params?.field_name?.action,
            key: 'action',
        },
        {
            name: '会議室',
            value: params?.field_name?.conference_room,
            key: 'conference_room',
        },
        {
            name: '開催時間',
            value: params?.field_name?.open_time,
            key: 'open_time',
        },
        {
            name: '講演者プロフィール',
            value: params?.field_name?.speaker_profile,
            key: 'speaker_profile',
        },
        {
            name: '申込最大人数',
            value: params?.field_name?.maximum_number_applicants,
            key: 'maximum_number_applicants',
        },
        {
            name: '音声・動画登録',
            value: params?.field_name?.audio_video_registration,
            key: 'audio_video_registration',
        },
        {
            name: '講演資料',
            value: params?.field_name?.lecture_materials,
            key: 'lecture_materials',
        },
        {
            name: '資料請求受付',
            value: params?.field_name?.document_request_reception,
            key: 'document_request_reception',
        },
        {
            name: 'アンケート',
            value: params?.field_name?.questionnaire,
            key: 'questionnaire',
        },
        {
            name: '料金',
            value: params?.field_name?.price,
            key: 'price',
        },
        {
            name: 'お問合せ',
            value: params?.field_name?.inquiries,
            key: 'inquiries',
        },
        {
            name: '月日',
            value: params?.field_name?.time_register,
            key: 'time_register',
        },
        {
            name: '時間帯',
            value: params?.field_name?.time_zone,
            key: 'time_zone',
        },
    ],
    button_name: [
        {
            name: '講演者写真',
            value: params?.button_name?.speaker_photo_button,
            key: 'speaker_photo_button',
        },
        {
            name: 'プレビュー',
            value: params?.button_name?.seminar_preview,
            key: 'seminar_preview',
        },
    ],
});

CustomItemSeminarSiteOrganDefault.defaultProps = {
    params: {},
};

CustomItemSeminarSiteOrganDefault.propTypes = {
    params: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export const CustomItemExhibitionSiteOrganDefault = (params) => ({
    screen_name: [
        {
            name: '展示商品管理',
            value: params?.screen_name?.exhibit_product_management,
            key: 'exhibit_product_management',
        },
        {
            name: '展示商品登録',
            value: params?.screen_name?.exhibition_product_registration,
            key: 'exhibition_product_registration',
        },
        {
            name: '展示商品詳細',
            value: params?.screen_name?.exhibit_product_details,
            key: 'exhibit_product_details',
        },
        {
            name: '展示商品編集',
            value: params?.screen_name?.exhibition_product_editing,
            key: 'exhibition_product_editing',
        },
    ],
    field_name: [
        {
            name: '商品名',
            value: params?.field_name?.product_name,
            key: 'product_name',
        },
        {
            name: '説明',
            value: params?.field_name?.explanation,
            key: 'explanation',
        },
        {
            name: 'メディアタイプ',
            value: params?.field_name?.media_type,
            key: 'media_type',
        },
        {
            name: '動画・音声・画像（再生時間）',
            value: params?.field_name?.playback_time,
            key: 'playback_time',
        },
        {
            name: 'アクション',
            value: params?.field_name?.action,
            key: 'action',
        },
        {
            name: 'ソート',
            value: params?.field_name?.sort,
            key: 'sort',
        },
        {
            name: '商品イメージ',
            value: params?.field_name?.product_image,
            key: 'product_image',
        },
        {
            name: '商品説明',
            value: params?.field_name?.description,
            key: 'description',
        },
        {
            name: '商品購入',
            value: params?.field_name?.product_purchase,
            key: 'product_purchase',
        },
        {
            name: '担当者と直接相談',
            value: params?.field_name?.direct_consultation,
            key: 'direct_consultation',
        },
        {
            name: '資料アップロード',
            value: params?.field_name?.material_upload,
            key: 'material_upload',
        },
        {
            name: '資料請求',
            value: params?.field_name?.document_request,
            key: 'document_request',
        },
        {
            name: 'アンケート',
            value: params?.field_name?.questionnaire,
            key: 'questionnaire',
        },
        {
            name: '商談／お問合せ',
            value: params?.field_name?.business_negotiations_inquiries,
            key: 'business_negotiations_inquiries',
        },
        {
            name: '喫茶掲示板ルーム',
            value: params?.field_name?.board_room,
            key: 'board_room',
        },
        {
            name: '外部リンク',
            value: params?.field_name?.external_link,
            key: 'external_link',
        },
        {
            name: '名刺交換',
            value: params?.field_name?.business_card_exchange,
            key: 'business_card_exchange',
        },
        {
            name: '料金',
            value: params?.field_name?.price,
            key: 'price',
        },
        {
            name: '合計数量',
            value: params?.field_name?.total_quantity,
            key: 'total_quantity',
        },
    ],
    button_name: [
        {
            name: '出展登録作業',
            value: params?.button_name?.exhibitor_registration_work,
            key: 'exhibitor_registration_work',
        },
        {
            name: '登録する',
            value: params?.button_name?.sign_up,
            key: 'sign_up',
        },
        {
            name: '変更する',
            value: params?.button_name?.change,
            key: 'change',
        },
        {
            name: 'プレビュー',
            value: params?.button_name?.exhibitor_preview,
            key: 'exhibitor_preview',
        },
    ],
});

CustomItemExhibitionSiteOrganDefault.defaultProps = {
    params: {},
};

CustomItemExhibitionSiteOrganDefault.propTypes = {
    params: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export const CustomItemSidebarSiteOrganDefault = (params) => ({
    screen_name: [
        {
            name: '出展者ログイン',
            value: params?.screen_name?.exhibitor_login,
            key: 'exhibitor_login',
        },
    ],
    field_name: [
        {
            name: '出展作業',
            value: params?.field_name?.exhibit_work,
            key: 'exhibit_work',
        },
        {
            name: '商品販売設定',
            value: params?.field_name?.product_sales_settings,
            key: 'product_sales_settings',
        },
        {
            name: 'セミナー登録作業',
            value: params?.field_name?.seminar_registration_work,
            key: 'seminar_registration_work',
        },
        {
            name: 'ライブ配信情報管理',
            value: params?.field_name?.livestreaming_info_management,
            key: 'livestreaming_info_management',
        },
        {
            name: '企業情報確認',
            value: params?.field_name?.confirmation_company_info,
            key: 'confirmation_company_info',
        },
        {
            name: 'よくあるご質問',
            value: params?.field_name?.faq,
            key: 'faq',
        },
        {
            name: '広告登録',
            value: params?.field_name?.advertising_registration,
            key: 'advertising_registration',
        },
        {
            name: 'アンケート',
            value: params?.field_name?.survey,
            key: 'survey',
        },
        {
            name: '出口',
            value: params?.field_name?.logout,
            key: 'logout',
        },
    ],
    button_name: [],
});

CustomItemSidebarSiteOrganDefault.defaultProps = {
    params: {},
};

CustomItemSidebarSiteOrganDefault.propTypes = {
    params: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export const CustomItemCompanySiteOrganDefault = (params, paramsLang, isLang) => ({
    screen_name: [
        {
            name: '企業情報更新修正作業',
            value: params?.screen_name?.company_info_update,
            key: 'company_info_update',
            lang: false,
            isShow: true,
        },
    ],
    field_name: [
        {
            name: '企業基本情報',
            value: params?.field_name?.basic_info,
            key: 'basic_info',
            lang: false,
            isShow: true,
        },
        {
            name: isLang ? '出展企業名（和文）' : '出展企業名',
            value: params?.field_name?.exhibitor_name,
            key: 'exhibitor_name',
            lang: false,
            isShow: true,
        },
        {
            name: '出展企業名（英文）',
            value: paramsLang?.field_name?.exhibitor_name,
            key: 'exhibitor_name',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '業種（和文）' : '業種',
            value: params?.field_name?.industry_type,
            key: 'industry_type',
            lang: false,
            isShow: true,
        },
        {
            name: '業種（英文）',
            value: paramsLang?.field_name?.industry_type,
            key: 'industry_type',
            lang: true,
            isShow: isLang,
        },
        {
            name: '職種',
            value: params?.field_name?.job_type,
            key: 'job_type',
            lang: false,
            isShow: true,
        },
        {
            name: '従業員数',
            value: params?.field_name?.number_employees,
            key: 'number_employees',
            lang: false,
            isShow: true,
        },
        {
            name: '連絡担当者',
            value: params?.field_name?.contact_person,
            key: 'contact_person',
            lang: false,
            isShow: true,
        },
        {
            name: '国・地域',
            value: params?.field_name?.country_region,
            key: 'country_region',
            lang: false,
            isShow: true,
        },
        {
            name: '部署',
            value: params?.field_name?.department,
            key: 'department',
            lang: false,
            isShow: true,
        },
        {
            name: '役職',
            value: params?.field_name?.position,
            key: 'position',
            lang: false,
            isShow: true,
        },
        {
            name: '氏名',
            value: params?.field_name?.name,
            key: 'name',
            lang: false,
            isShow: true,
        },
        {
            name: isLang ? '郵便番号（和文）' : '郵便番号',
            value: params?.field_name?.zip_code,
            key: 'zip_code',
            lang: false,
            isShow: true,
        },
        {
            name: '郵便番号（英文）',
            value: paramsLang?.field_name?.zip_code,
            key: 'zip_code',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '住所（和文）' : '住所',
            value: params?.field_name?.address,
            key: 'address',
            lang: false,
            isShow: true,
        },
        {
            name: '住所（英文）',
            value: paramsLang?.field_name?.address,
            key: 'address',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '電話番号（和文）' : '電話番号',
            value: params?.field_name?.phone_number,
            key: 'phone_number',
            lang: false,
            isShow: true,
        },
        {
            name: '電話番号（英文）',
            value: paramsLang?.field_name?.phone_number,
            key: 'phone_number',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'FAX 番号（和文）' : 'FAX 番号',
            value: params?.field_name?.fax_number,
            key: 'fax_number',
            lang: false,
            isShow: true,
        },
        {
            name: 'FAX 番号（英文）',
            value: paramsLang?.field_name?.fax_number,
            key: 'fax_number',
            lang: true,
            isShow: isLang,
        },
        {
            name: '名刺用メールアドレス',
            value: params?.field_name?.business_card_email,
            key: 'business_card_email',
            lang: false,
            isShow: true,
        },
        {
            name: '通知先メールアドレス',
            value: params?.field_name?.notification_email,
            key: 'notification_email',
            lang: false,
            isShow: true,
        },
        {
            name: '社名',
            value: params?.field_name?.company_name,
            key: 'company_name',
            lang: false,
            isShow: true,
        },
        {
            name: '展示会への開催',
            value: params?.field_name?.exhibition_hold,
            key: 'exhibition_hold',
            lang: false,
            isShow: true,
        },
        {
            name: 'セミナーの開催',
            value: params?.field_name?.seminar_hold,
            key: 'seminar_hold',
            lang: false,
            isShow: true,
        },
        {
            name: 'ライブ配信の開催',
            value: params?.field_name?.livestream_hold,
            key: 'livestream_hold',
            lang: false,
            isShow: true,
        },
        {
            name: 'メールアドレス',
            value: params?.field_name?.email,
            key: 'email',
            lang: false,
            isShow: true,
        },
        {
            name: isLang ? 'URL（和文）' : 'URL',
            value: params?.field_name?.url,
            key: 'url',
            lang: false,
            isShow: true,
        },
        {
            name: 'URL（英文）',
            value: paramsLang?.field_name?.url,
            key: 'url',
            lang: true,
            isShow: isLang,
        },
        {
            name: 'ガイド画像',
            value: params?.field_name?.guide_image,
            key: 'guide_image',
            lang: false,
            isShow: true,
        },
        {
            name: isLang ? 'ガイド情報（和文）' : 'ガイド情報',
            value: params?.field_name?.info_guide,
            key: 'info_guide',
            lang: false,
            isShow: true,
        },
        {
            name: 'ガイド情報（英文）',
            value: paramsLang?.field_name?.info_guide,
            key: 'info_guide',
            lang: true,
            isShow: isLang,
        },
        {
            name: 'セミナー',
            value: params?.field_name?.seminar,
            key: 'seminar',
            lang: false,
            isShow: true,
        },
        {
            name: 'ライブ配信',
            value: params?.field_name?.livestream,
            key: 'livestream',
            lang: false,
            isShow: true,
        },
        {
            name: 'ブース',
            value: params?.field_name?.zone,
            key: 'zone',
            lang: false,
            isShow: true,
        },
        {
            name: '支払い方法',
            value: params?.field_name?.exhibitor_payment,
            key: 'exhibitor_payment',
            lang: false,
            isShow: true,
        },
    ],
    button_name: [
        {
            name: '更新修正作業する',
            value: params?.button_name?.update_correction_work,
            key: 'update_correction_work',
            lang: false,
            isShow: true,
        },
        {
            name: 'Upload an Image',
            value: params?.button_name?.upload_image,
            key: 'upload_image',
            lang: false,
            isShow: true,
        },
    ],
});

CustomItemCompanySiteOrganDefault.defaultProps = {
    params: {},
    paramsLang: {},
    isLang: false,
};

CustomItemCompanySiteOrganDefault.propTypes = {
    params: PropTypes.oneOfType([() => null, PropTypes.object]),
    paramsLang: PropTypes.oneOfType([() => null, PropTypes.object]),
    isLang: PropTypes.bool,
};
